/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';
import type { VaccinatedRecord } from './VaccinatedRecord';
import {
    VaccinatedRecordFromJSON,
    VaccinatedRecordFromJSONTyped,
    VaccinatedRecordToJSON,
} from './VaccinatedRecord';

/**
 * 
 * @export
 * @interface VaccinatedRecordPagination
 */
export interface VaccinatedRecordPagination {
    /**
     * 
     * @type {Array<VaccinatedRecord>}
     * @memberof VaccinatedRecordPagination
     */
    data?: Array<VaccinatedRecord>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof VaccinatedRecordPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the VaccinatedRecordPagination interface.
 */
export function instanceOfVaccinatedRecordPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VaccinatedRecordPaginationFromJSON(json: any): VaccinatedRecordPagination {
    return VaccinatedRecordPaginationFromJSONTyped(json, false);
}

export function VaccinatedRecordPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaccinatedRecordPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(VaccinatedRecordFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function VaccinatedRecordPaginationToJSON(value?: VaccinatedRecordPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(VaccinatedRecordToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

